module.exports = __webpack_public_path__ + "img/banner-differents-old.d391713c.jpg";